/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const initAccountView = function () {
  $('.show-hide-orders').each(function () {
    $(this).on('click', function () {
      $(this).closest('.subscriptionSection').find('.subscriptionOrders').slideToggle('slow');
      $(this).closest('.subscriptionSection').find('.down-arrow').toggleClass('arrow-inital arrow-rotate');
    });
  });
};

module.exports = {
  initAccountView: initAccountView
};
